module.exports = __webpack_public_path__ + "static/media/error.b593cc73.svg";